/**
 * Manage hero slider (utilizes Slick slider package)
 */

/* global jQuery */

const $         = jQuery;   // jQuery loaded via WordPress enqueue process
const events    = require('../utilities/events');

let $sliders = null;

function initHeroSliders() {
    $sliders.each(function () {
        let $slider = $(this).find('.hero-slider__container'),
            $slides = $slider.find('.hero-slider__item');
            
        $slides.each(function () {
            let $slide = $(this),
                bg = $slide.data('image-src'),
                bgSm = $slide.data('image-src-sm'),                         // Alternate 'small' image (for mobile)
                txtMaxW = $slide.data('max-text-graphic-width'),            // Max width for our text graphic
                txtMaxWSm = $slide.data('max-text-graphic-width-small'),    // Max width for our SMALL text graphic
                $video = $slide.find('video'),                              // Grab reference to video, if one exists
                hasVideo = $video.length ? true : false;

            // Set up media query for detecting screen width changes
            const mq = window.matchMedia('(min-width: 768px)');
            mq.addListener(handleWidthChange);

            if ((bgSm !== undefined && bgSm !== '') || (txtMaxWSm !== undefined && txtMaxWSm !== '')) {
                // If small image is available, or size setting for small text
                // graphic has been specified, use media query to determine
                // which image to load and size to set (for text graphic)
                handleWidthChange(mq);
            } else if (bg !== undefined && bg !== '') {
                // Otherwise, just load larger image
                $slide.css('background-image', 'url("' + bg + '")');
                // ...and set the max text size.  Note that we're using
                // srcset media query specifications in-page to load
                // the correct text graphic.
                if (txtMaxW !== undefined && txtMaxW !== '') {
                    $slide.find('.hero-slider__text-graphic').css('max-width', txtMaxW + 'px');
                }
            }

            // Define function for managing media query
            function handleWidthChange(mq) {
                if (mq.matches) {
                    // Window is at least 768px wide
                    if (bg !== undefined && bg !== '') {
                        $slide.css('background-image', 'url("' + bg + '")');
                    } else {
                        // No desktop size image is available.  Let's just clear
                        // out the background image, in case was previously set
                        // to mobile image
                        $slide.css('background-image', '');
                    }
                    // Set the larger text graphic width (if one is in use).  Page
                    // handles loading of the correct image.
                    if (txtMaxW !== undefined && txtMaxW !== '') {
                        $slide.find('.hero-slider__text-graphic').css('max-width', txtMaxW + 'px');
                    }
                    // Check for video status (play if one is present)
                    if (hasVideo) {
                        $video.get(0).muted = true;
                        $video.get(0).play();
                    }
                } else {
                    // Window is less than 768px wide
                    if (bgSm !== undefined && bgSm !== '') {
                        $slide.css('background-image', 'url("' + bgSm + '")');
                    }
                    // Set the smaller text graphic width (if one is in use).  Page
                    // handles loading of the correct image.
                    if (txtMaxWSm !== undefined && txtMaxWSm !== '') {
                        $slide.find('.hero-slider__text-graphic').css('max-width', txtMaxWSm + 'px');
                    }
                    // Also, if current slide has a video, make sure
                    // it's paused
                    if (hasVideo) {
                        $video.get(0).pause();
                    }
                }
            }

            // If this is a video slide, play the video
            if (hasVideo) {
                // $video[0].play();
            }

            

        });
    
        

        // Set up handlers for before/after slide change events
        $slider.on('init', (event, slick) => {
            checkVideoPlay(slick.currentSlide);
        });
        $slider.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
            checkVideoPause(currentSlide);
            checkVideoPlay(nextSlide);
            // Dispatch the event
            $('body').trigger(events.SLIDE_CHANGE, nextSlide);
        });

        // Set up listener for pause requests
        $('body').on(events.REQUEST_SLIDER_PAUSE, () => {
            $slider.slick('slickPause');
        });

        function checkVideoPlay(index) {
            let $video = $($slides.get(index)).find('video'),      // Grab reference to video, if one exists
                hasVideo = $video.length ? true : false,
                isMobile = ($(window).width() < 768) ? true : false;

            if (hasVideo && !isMobile) {
                $video.get(0).muted = true;
                $video.get(0).play();
            }
        }
        function checkVideoPause(index) {
            let $video = $($slides.get(index)).find('video'),      // Grab reference to video, if one exists
                hasVideo = $video.length ? true : false,
                isMobile = ($(window).width() < 768) ? true : false;

            if (hasVideo && !isMobile) {
                $video.get(0).pause();
            }
        }

        $slider.slick({
            dots: true,
            arrows: false,
            infinite: true,
            speed: 1000,
            adaptiveHeight: false,
            autoplay: true,
            autoplaySpeed: 6500,
            pauseOnHover: false,
            pauseOnFocus: false,
            pauseOnDotsHover: true,
            fade: true
        });

    });
}


exports.init = function ($els) {
    $sliders = $els;

    initHeroSliders();
};